import { Home, Users, Building2, HeartPulse, Brain } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const CARE_COST_DISCLAIMER =
  'Cost data is provided by CareScout, a subsidiary of Genworth Financial. Actual costs vary by provider, location, and level of care. This tool provides estimates and is not financial or medical advice.' as const;

export const CARESCOUT_ATTRIBUTION =
  'Cost of Care Tool provided by CareScout. This resource can help you understand median costs of long-term care services in your area.' as const;

type CareTypeCardData = {
  icon: LucideIcon;
  title: string;
  body: string;
};

export const CARE_TYPE_CARDS: readonly CareTypeCardData[] = [
  {
    icon: Home,
    title: 'In-Home Care',
    body: "A caregiver comes to your loved one's home to help with daily activities like bathing, meals, and medication reminders. Support can range from a few hours a week to round-the-clock care.",
  },
  {
    icon: Users,
    title: 'Adult Day Services',
    body: 'Adult day programs offer structured activities, social connection, and health monitoring during daytime hours — a great fit for families who need support while continuing to work.',
  },
  {
    icon: Building2,
    title: 'Assisted Living',
    body: 'Assisted living communities provide housing, meals, and help with daily tasks in a residential setting. Residents stay independent while having support available when they need it.',
  },
  {
    icon: HeartPulse,
    title: 'Nursing Home / Skilled Nursing',
    body: 'Nursing homes offer 24/7 medical care and rehabilitation for those with complex health needs. This level of care is common after a hospital stay or for ongoing medical conditions.',
  },
  {
    icon: Brain,
    title: 'Memory Care',
    body: "Memory care communities are designed for people living with Alzheimer's or other forms of dementia — with secure environments, specialized programming, and staff trained in dementia care.",
  },
] as const;
